import { createReducer, on } from '@ngrx/store';
import * as fromOrdersActions from '../../actions/orders/orders.actions';

export const ordersFeatureKey = 'orders';

export interface State {
  retailOrders: any;
  orderData: any;
}

export const initialState: State = {
  retailOrders: null,
  orderData: null
};

export const reducer = createReducer(
  initialState,
  on(fromOrdersActions.loadRetailOrdersDropdownSuccess, (state, action) => {
    return {
      ...state,
      orders: action.retailOrders
    };
  }),
  on(fromOrdersActions.loadRetailOrdersDropdownData, (state, action) => {
    return {
      ...state,
      orderData: action.orderData
    };
  })
);
